import React, { FC, Fragment } from 'react'
import { Button, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import ResponsiveModal from '@src/components/ResponsiveModal'
import { FormattedMessage } from 'react-intl'
import MobileFacetGroup from './MobileFacetGroup'
import MobileFilterFacets from './MobileFilterFacets'
import { Facet } from '@src/types/graphql-types'
import FormattedFacetMessage from '../Facets/FormattedFacetMessage'
import FacetSelections from '../FacetSelections/FacetSelections'

const useStyles = makeStyles()((theme) => ({
  body: {
    overflow: 'scroll',
    padding: theme.spacing(6, 4),
  },
  footer: {
    padding: theme.spacing(6, 4),
  },
}))

interface Props {
  facets?: Facet[]
  isStructureSearch: boolean
  isModalOpen: boolean
  onModalClose(): void
  showSortBar?: boolean
}

const MobileFilterAndFacetModal: FC<Props> = ({
  facets,
  isStructureSearch,
  isModalOpen,
  onModalClose,
}) => {
  const { classes } = useStyles()

  return (
    <ResponsiveModal
      open={isModalOpen}
      data-testid="mobile-filter-and-facet-modal"
      onClose={onModalClose}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          <FormattedMessage id="FILTER" defaultMessage="Filter" />
        </Typography>
      )}
    >
      <>
        <div className={classes.body}>
          <FacetSelections
            facets={facets}
            isStructureSearch={isStructureSearch}
          />

          {!!facets &&
            facets.map((facet) => (
              <Fragment key={facet.key}>
                <MobileFacetGroup
                  renderHeading={() => (
                    <Typography variant="body1" component="h2">
                      <b>
                        <FormattedFacetMessage id={facet.key.toUpperCase()} />
                      </b>
                    </Typography>
                  )}
                >
                  <MobileFilterFacets facet={facet} allFacets={facets} />
                </MobileFacetGroup>
              </Fragment>
            ))}
        </div>
        <div className={classes.footer}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            onClick={onModalClose}
          >
            <FormattedMessage id="DONE" defaultMessage="Done" />
          </Button>
        </div>
      </>
    </ResponsiveModal>
  )
}

export default MobileFilterAndFacetModal
